import React, {useState, useRef, useMemo} from 'react';
import { useFormik } from 'formik';
import companyService from '../../../services/data/company.service';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import FormAddCategory from './formAddCategory';
import { renderHeaderEditor } from '../../../helpers/editorToolbar';
import { Editor } from 'primereact/editor';
import moment from "moment";
import 'moment/locale/pt-br'


export default function FormAddBenefit(props) {
    
    const [showCategory, setShowCategory] = useState(false)
    const toast = useRef(null);
    const headerEditor = renderHeaderEditor();

    const [objId, setObjId] = useState('')
    const [title, setTitle] = useState('')
    const [supplier, setSupplier] = useState('')
    const [category, setCategory] = useState('')
    const [categoryList, setCategoryList] = useState('')
    const [description, setDescription] = useState('')
    const [dateActive, setDateActive] = useState('')
    const [inactive, setInactive] = useState(false)
    const [dateInactive, setDateInactive] = useState('')

    useMemo(() => {
        if(props.obj) {
            setObjId(props.obj.id)
            setTitle(props.obj.title)
            setSupplier(props.obj.supplier)
            if (props.obj.category) {
                setCategory(props.obj.category.id)
            }
            setDescription(props.obj.description)
            setDateActive(
                moment(props.obj.date_active).format("YYYY-MM-DD")
            )
            if (props.obj.inactive) {
                setInactive(props.obj.inactive)
            }
            if (props.obj.date_inactive){
                setDateInactive(
                    moment(props.obj.date_inactive).format("YYYY-MM-DD")
                )
            }
        }
        if (props.categories && props.categories.results && props.categories.results.length > 0) {
            setCategoryList(props.categories.results)
        }
        if (props.categoriesList && props.categoriesList.length > 0) {
            setCategoryList(props.categoriesList)
        }
    }, [props])

    function listCategories() {
        let _data = {
            company_id: localStorage.getItem("companyId"),
            model: 'benefits'
        }
        companyService.listCategory(1, _data).then((response) => {
            setCategoryList(response.results)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    const handleShowCategory = () => {
        setShowCategory(!showCategory)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: title,
            supplier: supplier,
            category: category,
            description: description,
            date_active: dateActive,
            inactive: inactive,
            date_inactive: dateInactive,
        },
        onSubmit: values => {

            let data = {
                company_id: localStorage.getItem("companyId"),
                title: values.title,
                supplier: values.supplier,
                category_id: values.category,
                description: values.description,
                date_active: values.date_active,
                inactive: values.inactive,
            }
            if (values.inactive) {
                data.date_inactive = values.date_inactive
            }

            if (objId) {

                data.id = objId
    
                companyService.updateBenefit(data).then(() => {
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Benefício atualizado com sucesso', life: 3000 });
                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data, life: 4000 });
                });

            } else {
                companyService.createBenefit(data).then(() => {
    
                    if (props.listItems) {
                        props.listItems()
                    }
                    
                    toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Benefício criado com sucesso', life: 3000 });
                    
                    formik.resetForm()
                    setDescription('')

                    if (props.hideModal) {
                        setTimeout(() => {
                            props.hideModal()
                        }, 3000);
                    }
                    
    
                }).catch((error) => {
                    toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data, life: 4000 });
                });
            }
            
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <Toast ref={toast} position="top-right" />
        
            <div className="col">
                <label className="form-label">Nome do Benefício <span className="text-danger">*</span></label>
                <input name='title' type="text" className="form-control text-capitalize" required {...formik.getFieldProps('title')} />
            </div>

            <div className="col mt-3">
                <label className="form-label">Fornecedor <span className="text-danger">*</span></label>
                <input name='supplier' type="text" className="form-control text-capitalize" {...formik.getFieldProps('supplier')} />
            </div>

            <div className="col mt-3">
                <label className="form-label">Categoria</label>
                <button className="btn btn-sm" onClick={(e) => handleShowCategory(e)}>
                    <FontAwesomeIcon className='text-green font150' icon={solid('plus-circle')} />
                </button>
                
                {
                    showCategory ?
                    <>
                    <div className='mt-3 p-2 bg-light'>
                        <FormAddCategory model='benefits' setCategory={setCategory} listCategories={listCategories} handleShowCategory={handleShowCategory} />
                    </div>
                    <hr/>
                    </>
                    :
                    null
                }
                {
                    categoryList ?
                    <select className='form-select mb-3' {...formik.getFieldProps('category')}>
                        <option value=''>Sem Categoria</option>
                        {
                            categoryList.map((item, index) =>
                            <option key={index} value={item.id}>{item.title}</option>
                            )
                        }
                    </select>
                    :
                    null
                }
            </div>

            <div className="my-3">
                <label className="form-label">Descrição</label>
                <Editor
                    name="description"
                    style={{ height: '120px' }}
                    headerTemplate={headerEditor}
                    value={formik.values.description}
                    onTextChange={(e) => {
                        formik.setFieldValue('description', e.htmlValue);
                    }}
                />
            </div>

            <div className='mb-4 col-md-6'>
                <label className="form-label">Ativo a partir de</label>
                <input className="form-control" name='date_active' type="date" required="required" autoComplete="off" {...formik.getFieldProps('date_active')} />
            </div>

            <div className="form-check form-switch mb-4">
                <label className="form-switch-label align-baseline">Benefício Inativo?</label>
                <input className="form-check-input" type="checkbox" role="switch" name='inactive' aria-checked={formik.values.inactive} checked={formik.values.inactive} {...formik.getFieldProps('inactive')} />
            </div>

            {
                formik.values.inactive ?
                <>
                <div className='mb-4 col-md-6'>
                    <label className="form-label">Inativo a partir de</label>
                    <input className="form-control" name='date_inactive' type="date" required="required" autoComplete="off" {...formik.getFieldProps('date_inactive')} />
                </div>
                </>
                :
                null
            }

            <hr/>
            <div className="d-grid mx-auto btnMargin">
                <button className="btn btn-success btn-sm btn-rounded" type="submit">
                    {
                        objId ?
                        <>Atualizar</>
                        :
                        <>Adicionar</>
                    }
                </button>
            </div>
        </form>
    )
}